/*
 * Opens a letter in a dialog.
 *
 * The trigger is a real link to the dialog's id, so with no JavaScript the
 * browser still jumps to the letter and the letter is readable. With it, the
 * link opens the dialog instead — and <dialog> brings Escape, the focus trap
 * and the backdrop with it, so none of that is written here.
 */
(() => {
  class BhaktaLetter extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      const open = this.querySelector('[data-bk-letter-open]');
      if (!this.dialog || !open) return;

      open.addEventListener('click', (event) => {
        event.preventDefault();
        this.dialog.showModal();
      });

      const close = this.querySelector('[data-bk-letter-close]');
      if (close) close.addEventListener('click', () => this.dialog.close());

      /*
       * A click on the backdrop lands on the dialog element itself rather than
       * on anything inside it, which is how the two are told apart.
       */
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
    }
  }

  if (!customElements.get('bhakta-letter')) {
    customElements.define('bhakta-letter', BhaktaLetter);
  }
})();
